<div
    class="card-description selenium-card-description"
    [ngStyle]="{ height: height ? height + 'px' : 'auto' }"
>
    <ng-content></ng-content>
</div>
